import React from 'react';

interface DefaultContactIconProps {
  size?: number;
}

const DefaultContactIcon: React.FC<DefaultContactIconProps> = ({
  size = 32
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
        d="M16 1C24.2843 1 31 7.71573 31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1Z"
        fill="url(#pattern0_12871_27175)"
        stroke="white"
        strokeWidth="2"
      />
      <defs>
        <pattern
          id="pattern0_12871_27175"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_12871_27175" transform="scale(0.0208333)" />
        </pattern>
        <image
          id="image0_12871_27175"
          width="48"
          height="48"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAACz0lEQVRoBe1Y227aQBA9XIzKJYQkFNEACiRVK/X3+9b3fkKkNCUhNIEUCBDAXILBdIfEEiBbeL1jVZE8kmV7d2b2nB3vemZD33/8XOEdS/gdY19DDwj87wgGEQgioDgDwSekOIHK5lFlDzYOIpEwUsk4UonEulefTKCPp1guTRtttSZ2AsXTHD6XCwiFQlvIzNUK1VoDjcf2VrvqCxsBLRrBt68VHGfStpjCgtCX8yIy6SSuqnW2aLAt4spZwRH8JqNc9ggX5eJmk9IzCwGa9UI+6xoI6TpFyrWTN0UWAqVCTnZceLGxG4SFQCr5utvYDeDUdpCIO3VJtSsTSMY/IKbJ7wVaTAPZqooyAWOx9Ixh+jL3bGsZKhOYGwbmc8Py5/o+ns5gmuo/NmUChFifTF0DtxTHuryNZbt5ZyFQqz+C/rRuZSV0/zR5/sgsBIb6GHf1plv8qN41MBI2HCK/fTiMWm+0QAv6QuRBUZFW2MlC9N8I8M3Wk123pzY2AjQ6AXvqDVA8/Yh0Kimy0ddtUp/MQFF6aHZAi55TWAkQMAJ4K/E5qZJhWQOqIFTsPUUgfZDA8aFIm8PbOb9nIOYKvcEIw5H8wpYmUKKCpcKXDlukK+Lh+vZeFDwdq8nVXfoTOit9cuXYi1K5mJc2kyZAlZdfEhMJnqxIE5AdwG/9gIDfM7zPfxCBfTPkd38QAb9neJ//IAL7ZsjvfukIXF7VYBgLdlx0MEC+ZUU6mWt3++gPR+KgtgQ65+SQdqeP69q9p4mRJkCAKQKXv2rr8rAkqq98LutYRjoRpPLzb6uLB3HcPlM4H/JEwAJFA/8WZ/43ogI7yRwim83g5CgNLWrvdi6Id/sDPHWf0esPpU4yrDF37/Yj7WrteTdFQdLpPa8vUqWMNSpIaG9HjhQxY7EAFfXcwkJgFxR9HnRNZy+7Xezv0rsQOwJFhwEBxQlUNv8HtlTg0q061DsAAAAASUVORK5CYII="
        />
      </defs>
    </svg>
  );
};

export default DefaultContactIcon;
